import type { ReactNode } from 'react';

export function LinkCardGrid({ children }: { children: ReactNode }) {
  return <div className="grid grid-cols-1 gap-2 sm:grid-cols-2 md:grid-cols-3">{children}</div>;
}
